import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import CustomTypography from '../../../components/Typography/CustomTypography';
import Button from '../../../components/Button/CustomButton';
import SnackBar from '../../../components/Snackbar/Snackbar';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTable from '../../../components/Table/Table';
import DialogProductExhibition from '../../../containers/admin/CompanyManagement/DialogProductExhibition';
import AlertDialog from '../../../components/Dialog/AlertDialog';
import Pagination from '../../../components/Pagination/Pagination';
import Loader from '../../../components/Loader/Loader';
import { boothType, BOOTH_TYPE, MEDIA_TYPE } from '../../../common/Constants';

import { convertDuration } from '../../../utils/dateUtils';
import { ArrowDownward, ArrowUpward } from '../../../components/Icons/Icon';
import styles from '../../../assets/jss/pages/listProductExhibition';

const useStyles = makeStyles(styles);

const ActionRow = ({ onEdit, onDelete, ...rest }) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
        <Button onClick={onEdit} color="success" {...rest} style={{ fontSize: '14px' }}>編集</Button>
        &nbsp;
        <Button onClick={onDelete} color="danger" {...rest} style={{ fontSize: '14px' }}>削除</Button>
    </Box>
);

const ListProductExhibition = (props) => {
    const {
        fetchListProduct: fetchList,
        getSettingBooth,
        settingBoothData,
        fetchDeleteProduct,
        listProductExhibition: products,
        // page,
        // totalPage,
        isFechingDelete,
        errorsDelete,
        deleteSuccess,
        fetchClearDeleteProduct,
        fetchGetDetailCompany,
        fetchClearGetDetailCompany,
        companyDetail,
        editSuccess,
        fetchClearEditExhibition,
        token,
        isLoading,
        updateProductOrder, updateOrderSuccess, updateOrderError, clearUpdateProductOrder,
    } = props;

    const PAGE_SIZE = 20;
    const PULL_ACTION = {
        UP: 1,
        DOWN: 0,
    };
    const classes = useStyles();
    const params = useParams();
    const intl = useIntl();
    const [isOpenDialogEdit, setIsOpenDialogEdit] = useState(false);
    const [isOpenDialogDelete, setIsOpenDialogDelete] = useState({ isOpen: false, waitingOrder: false });
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);
    const [productId, setProductId] = useState(0);
    const [modeDialog, setModeDialog] = useState(1);
    const [boothName, setBoothName] = useState('');
    const [errorDialog, setErrorDialog] = useState({ isOpen: false, message: '' });

    const [reOrderMode, setReOrderMode] = useState(false);
    const [reOrderBlocks, setReOrderBlocks] = useState({});
    const [reOrderList, setReOrderList] = useState([]);
    const [reOrderIndexList, setReOrderIndexList] = useState([]);

    const indexPage = useRef(null);
    const activeIndex = useRef(null);
    const pullAction = useRef(null);
    const relatedPage = useRef(null);

    const isNeedFetchProducts = () => {
        if (pullAction.current === PULL_ACTION.UP && activeIndex.current % PAGE_SIZE === 0) {
            if (indexPage.current > 0 && _.isUndefined(reOrderBlocks[`${indexPage.current - 1}`])) return true;
        }

        if (pullAction.current === PULL_ACTION.DOWN && (activeIndex.current + 1) % PAGE_SIZE === 0) {
            if (indexPage.current < products.total_page && _.isUndefined(reOrderBlocks[`${indexPage.current + 1}`])) return true;
        }

        return false;
    };

    const getRelatedPage = (page) => {
        if (pullAction.current === PULL_ACTION.UP && activeIndex.current % PAGE_SIZE === 0) {
            return page - 1;
        }

        if (pullAction.current === PULL_ACTION.DOWN && (activeIndex.current + 1) % PAGE_SIZE === 0) {
            return page + 1;
        }

        return page;
    };

    const createReOrderList = (page) => {
        let startIndex = (page - 1) * PAGE_SIZE;
        let finishIndex = (page - 1) * PAGE_SIZE + reOrderBlocks[`${page}`].length;

        let newReOrderData = [...reOrderIndexList].slice(startIndex, finishIndex).map(item => {
            return reOrderBlocks[`${Math.floor(item / PAGE_SIZE) + 1}`][item % PAGE_SIZE];
        });

        setReOrderList(generateTableData(newReOrderData, page));
    };

    const createReOrderIndexList = (index, pullAction) => {
        let tempIndexList = !reOrderIndexList.length
            ? [...Array(products.total_length).keys()]
            : [...reOrderIndexList];

        if (pullAction === PULL_ACTION.UP) {
            [tempIndexList[index], tempIndexList[index - 1]] = [tempIndexList[index - 1], tempIndexList[index]];
        }

        if (pullAction === PULL_ACTION.DOWN) {
            [tempIndexList[index], tempIndexList[index + 1]] = [tempIndexList[index + 1], tempIndexList[index]];
        }

        setReOrderIndexList(tempIndexList);
    };

    const handlePullAction = (e, index, action) => {
        e.stopPropagation();
        if (!reOrderMode) setReOrderMode(true);

        activeIndex.current = index;
        pullAction.current = action;

        createReOrderIndexList(index, action);
    };

    const handleChangePage = (page) => {
        if (!reOrderMode) {
            fetchList(params.idCompany, { page });
        } else {
            if (_.isUndefined(reOrderBlocks[`${page}`])) {
                relatedPage.current = products.page;
                fetchList(params.idCompany, { page });
            } else {
                indexPage.current = page;
                createReOrderList(page);
            }
        }
    };

    const clearReOrderState = () => {
        setReOrderMode(false);
        setReOrderBlocks({});
        setReOrderList([]);
        setReOrderIndexList([]);

        pullAction.current = null;
        activeIndex.current = null;
        indexPage.current = null;
        relatedPage.current = null;
    };

    const cancelReOrderProductList = () => {
        clearReOrderState();
        fetchList(params.idCompany, {page: 1});
    };

    const applyReOrderProductList = () => {
        let objSeq = {
            ob_seq: [],
        };

        for (let i = 0, length = reOrderIndexList.length; i < length; i++) {
            if (i !== reOrderIndexList[i]) {
                let newSeq = {
                    "product_id": reOrderBlocks[`${Math.floor(reOrderIndexList[i] / PAGE_SIZE) + 1}`][reOrderIndexList[i] % PAGE_SIZE].id,
                    "seq_update": reOrderBlocks[`${Math.floor(i / PAGE_SIZE) + 1}`][i % PAGE_SIZE].product_seq,
                };

                objSeq.ob_seq.push(newSeq);
            }
        }

        updateProductOrder(params.idCompany, objSeq);
    };

    const tableHead = companyDetail.organizerBooth === BOOTH_TYPE.GRAND
        ? ['商品名', '説明', '料金', '動画・音声・画像（再生時間）', 'アクション', 'アクション']
        : ['商品名', '説明', '動画・音声・画像（再生時間）', 'アクション', 'アクション'];

    const tableHeadWidth = companyDetail.organizerBooth === BOOTH_TYPE.GRAND
        ? ['20%', '25%', '10%', '15%', '15%', '15%']
        : ['20%', '35%', '15%', '15%', '15%'];

    const generateTableData = (data, page) => {
        const tableData = companyDetail.organizerBooth === BOOTH_TYPE.GRAND
            ? data.map((product, index) => [
                product.name,
                product.description,
                `${intl.formatNumber(product.price)}円`,
                product.media_type === MEDIA_TYPE.VIDEO || product.media_type === MEDIA_TYPE.AUDIO
                    ? convertDuration(
                        product.media_duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    ) : '',
                <ActionRow
                    onEdit={(e) => handleOpenDialogEdit(e, product.id, product.is_in_order_waiting)}
                    onDelete={(e) => handleOpenDialogDelete(e, product.id, product.is_in_order_waiting)}
                    size="sm"
                />,
                <SortAction
                    pullUp={(e) => handlePullAction(e, (page - 1) * PAGE_SIZE + index, PULL_ACTION.UP)}
                    pullDown={(e) => handlePullAction(e, (page - 1) * PAGE_SIZE + index, PULL_ACTION.DOWN)}
                    isBegin={page === 1 && index === 0}
                    isEnd={(page - 1) * PAGE_SIZE + index === products.total_length - 1}
                />,
            ])
            : data.map((product, index) => [
                product.name,
                product.description,
                product.media_type === MEDIA_TYPE.VIDEO || product.media_type === MEDIA_TYPE.AUDIO
                    ? convertDuration(
                        product.media_duration,
                        intl.formatMessage({ id: 'common.hour' }),
                        intl.formatMessage({ id: 'common.minute' }),
                        intl.formatMessage({ id: 'common.second' }),
                    ) : '',
                <ActionRow
                    onEdit={(e) => handleOpenDialogEdit(e, product.id, product.is_in_order_waiting)}
                    onDelete={(e) => handleOpenDialogDelete(e, product.id, product.is_in_order_waiting)}
                    size="sm"
                />,
                <SortAction
                    pullUp={(e) => handlePullAction(e, (page - 1) * PAGE_SIZE + index, PULL_ACTION.UP)}
                    pullDown={(e) => handlePullAction(e, (page - 1) * PAGE_SIZE + index, PULL_ACTION.DOWN)}
                    isBegin={page === 1 && index === 0}
                    isEnd={(page - 1) * PAGE_SIZE + index === products.total_length - 1}
                />,
            ]);

        return tableData;
    };

    useEffect(() => {
        if (Array.isArray(products.results) && !_.isEmpty(companyDetail)) {
            indexPage.current = products.page;

            if (reOrderMode) {
                if (_.isUndefined(reOrderBlocks[`${products.page}`])) {

                    setReOrderBlocks({
                        ...reOrderBlocks,
                        [`${products.page}`]: products.results,
                    });
                }
            } else {
                setReOrderBlocks({
                    ...reOrderBlocks,
                    [`${products.page}`]: products.results,
                });

                setReOrderList(generateTableData(products.results, products.page));
            }
        }
    }, [products, companyDetail]);

    useEffect(() => {
        if (_.isEmpty(reOrderBlocks)) return;

        if (!_.isUndefined(reOrderBlocks[`${indexPage.current}`]) && !_.isUndefined(reOrderBlocks[`${relatedPage.current}`])) {
            createReOrderList(indexPage.current);
        }
    }, [reOrderBlocks]);

    useEffect(() => {
        if (!reOrderIndexList.length) return;

        if (isNeedFetchProducts()) {
            relatedPage.current = getRelatedPage(products.page);

            if (_.isUndefined(reOrderBlocks[`${products.page}`])) {
                setReOrderBlocks({
                    ...reOrderBlocks,
                    [`${products.page}`]: products.results,
                });
            }

            fetchList(params.idCompany, {page: getRelatedPage(products.page)});
        } else {
            let nextPage = getRelatedPage(indexPage.current);
            indexPage.current = nextPage;

            if (_.isUndefined(reOrderBlocks[`${nextPage}`])) {
                relatedPage.current = nextPage;
                setReOrderBlocks({
                    ...reOrderBlocks,
                    [`${nextPage}`]: products.results,
                });
            } else {
                createReOrderList(nextPage);
            }
        }
    }, [reOrderIndexList]);

    useEffect(() => {
        if (updateOrderSuccess === true) {
            clearReOrderState();
            fetchList(params.idCompany);

            setErrorDialog({
                isOpen: true,
                severity: 'success',
                message: intl.formatMessage({ id: 'apiSuccess.update' }),
            });

            clearUpdateProductOrder();
        }

        if (!_.isEmpty(updateOrderError)) {
            setErrorDialog({
                isOpen: true,
                severity: 'error',
                message: updateOrderError.message,
            });

            clearUpdateProductOrder();
        }
    }, [updateOrderSuccess, updateOrderError, fetchList, clearUpdateProductOrder, params.idCompany]);

    const handleCloseErrorDialog = () => setErrorDialog({ ...errorDialog, isOpen: false });

    // =================================================

    useEffect(() => {
        if (!_.isEmpty(params)) {
            fetchList(params.idCompany);
            getSettingBooth(params.shortName);
            fetchGetDetailCompany({
                event_name: params.shortName,
                company_id: params.idCompany,
            });
        }

        return () => {
            fetchClearGetDetailCompany();
        };
    }, [params]);

    useEffect(() => {
        if (!_.isEmpty(companyDetail)) {
            const temp = settingBoothData[boothType[`${companyDetail.organizerBooth}`]];
            if (temp) { setBoothName(temp.name); }
        }
    }, [companyDetail]);

    useEffect(() => {
        if (editSuccess) {
            setIsOpenDialogEdit(false);
            fetchList(params.idCompany);
            fetchClearEditExhibition();
            setIsOpenSnackBar(true);
        }
    }, [editSuccess]);

    useEffect(() => {
        if (_.isEmpty(errorsDelete) && deleteSuccess) {
            fetchList(params.idCompany);
            handleCloseDialogDelete();
            setIsOpenSnackBar(true);
        }
        if (!isFechingDelete) {
            fetchClearDeleteProduct();
        }
    }, [isFechingDelete]);

    useEffect(() => {
        if (!_.isEmpty(errorsDelete)) {
            handleCloseDialogDelete();
            setErrorDialog({ isOpen: true, message: errorsDelete?.message?.message });
            fetchClearDeleteProduct();
        }
    }, [errorsDelete]);

    useEffect(() => {
        if (!isOpenDialogEdit) {
            setModeDialog(1);
        }
    }, [isOpenDialogEdit]);

    const handleChangeDialogMode = () => setModeDialog(2);

    const handleOpenDialogEdit = (e, pId, waitOrder) => {
        e.stopPropagation();
        setProductId(pId);
        setModeDialog(2);
        setIsOpenDialogEdit(true);
        setErrorDialog({
            isOpen: waitOrder,
            message: 'この商品が購入されていますが、承認されていません。名前、価格を変更したり、商品を削除したりする場合、この商品を含む注文が承認されなくなります。',
        });
    };

    const handleCloseDialogEdit = () => {
        setProductId(0);
        setIsOpenDialogEdit(false);
    };

    const handleOpenDialogDelete = (e, pId, waitOrder) => {
        e.stopPropagation();
        setProductId(pId);
        setIsOpenDialogDelete({ isOpen: true, waitingOrder: waitOrder });
    };

    const handleCloseDialogDelete = () => {
        setProductId(0);
        setIsOpenDialogDelete({ isOpen: false, waitingOrder: false });
    };

    const contentDeleteCompany = (wait) => (!wait ? '削除しますか？' : (
        <>
            <p>削除しますか？</p>
            <p>この商品が購入されていますが、承認されていません。</p>
            <p>名前、価格を変更したり、商品を削除したりする場合、この商品を含む注文が承認されなくなります。</p>
        </>
    ));

    const handleDeleteProduct = () => {
        fetchDeleteProduct({
            company_id: params.idCompany,
            product_id: productId,
        });
    };

    const handleShowDetailProduct = (index) => {
        setProductId(products.results[index].id);
        setModeDialog(1);
        setIsOpenDialogEdit(true);
    };

    return (
        <>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                        <CustomTypography variant="h4" color="info" bold>
                            {companyDetail.fullName}
                        </CustomTypography>
                    </GridItem>
                </GridItem>
                <GridItem xs={12} md={12}>
                    <CustomTypography variant="h6">
                        {`代表者: ${companyDetail.firstName} ${companyDetail.lastName}`}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} md={12}>
                    <CustomTypography variant="h6">
                        {`出展ブース: ${boothName}`}
                    </CustomTypography>
                </GridItem>
                <GridItem xs={12} md={12}>
                    {reOrderMode && (
                        <div className={classes.reOrderActionsWrapper}>
                            <Button
                                gradient
                                size="md"
                                color="warning"
                                className={classes.reOrderCancelBtn}
                                onClick={cancelReOrderProductList}
                            >
                                {intl.formatMessage({ id: 'cancel' })}
                            </Button>
                            <Button
                                gradient
                                size="md"
                                color="success"
                                className={classes.reOrderApplyBtn}
                                onClick={applyReOrderProductList}
                            >
                                {intl.formatMessage({ id: 'apply' })}
                            </Button>
                        </div>
                    )}

                    <CustomTable
                        onClick={handleShowDetailProduct}
                        tableHead={tableHead}
                        tableHeadWidth={tableHeadWidth}
                        tableData={reOrderList}
                        tableFooter={(
                            <Box display="flex" justifyContent="center">
                                <Pagination
                                    page={indexPage.current}
                                    total={products.total_page}
                                    onChange={(page) => handleChangePage(page)}
                                />
                            </Box>
                        )}
                        noDataMessage={(
                            <GridItem
                                xs={12}
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '20px',
                                    zIndex: 1,
                                }}
                            >
                                <FormattedMessage id="productManagement.noData" />
                            </GridItem>
                        )}
                    />
                </GridItem>
            </GridContainer>

            <DialogProductExhibition
                isOpen={isOpenDialogEdit}
                handleClose={() => handleCloseDialogEdit()}
                productId={productId}
                mode={modeDialog}
                onClickChangeToEditDialog={() => handleChangeDialogMode()}
                token={token}
                companyDetail={companyDetail}
                fetchList={() => fetchList(params.idCompany)}
            />

            <AlertDialog
                title={<FormattedMessage id="dialog.confirmDeleteTitle" />}
                handleClose={() => handleCloseDialogDelete()}
                handleOpen={isOpenDialogDelete.isOpen}
                handleSubmit={() => handleDeleteProduct()}
                contents={contentDeleteCompany(isOpenDialogDelete.waitingOrder)}
            />

            <SnackBar
                open={isOpenSnackBar}
                onClose={() => setIsOpenSnackBar(false)}
                message={intl.formatMessage({ id: 'apiSuccess.default' })}
                severity="success"
                autoHideDuration={3000}
            />
            <SnackBar
                open={errorDialog.isOpen}
                onClose={handleCloseErrorDialog}
                message={errorDialog.message}
                severity={errorDialog.severity}
                autoHideDuration={3000}
            />

            <Loader isLoading={isLoading} />
        </>
    );
};

ListProductExhibition.defaultProps = {
    listProductExhibition: [],
    // page: 1,
    // totalPage: 1,
    isFechingDelete: false,
    errorsDelete: {},
    settingBoothData: {},
    deleteSuccess: false,
    editSuccess: false,
    token: '',
};

ListProductExhibition.propTypes = {
    fetchListProduct: PropTypes.func.isRequired,
    getSettingBooth: PropTypes.func.isRequired,
    fetchDeleteProduct: PropTypes.func.isRequired,
    listProductExhibition: PropTypes.oneOfType([() => null, PropTypes.array]),
    // page: PropTypes.number,
    // totalPage: PropTypes.number,
    isFechingDelete: PropTypes.bool,
    errorsDelete: PropTypes.oneOfType([() => null, PropTypes.object]),
    settingBoothData: PropTypes.oneOfType([() => null, PropTypes.object]),
    deleteSuccess: PropTypes.bool,
    fetchClearDeleteProduct: PropTypes.func.isRequired,
    fetchGetDetailCompany: PropTypes.func.isRequired,
    fetchClearGetDetailCompany: PropTypes.func.isRequired,
    companyDetail: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    editSuccess: PropTypes.bool,
    fetchClearEditExhibition: PropTypes.func.isRequired,
    token: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
};

ActionRow.propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

const SortAction = ({
    pullUp, pullDown, isBegin, isEnd,
}) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
        <IconButton onClick={pullUp} disabled={isBegin}>
            <ArrowUpward />
        </IconButton>
        <IconButton onClick={pullDown} disabled={isEnd}>
            <ArrowDownward />
        </IconButton>
    </Box>
);

SortAction.propTypes = {
    pullUp: PropTypes.func.isRequired,
    pullDown: PropTypes.func.isRequired,
    isBegin: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
};

export default ListProductExhibition;
